import { call, put } from 'redux-saga/effects';
import { getIssueTypes } from "../../../lib/utilities/index";

const fetchIssueTypeData = async () => {
    try {
        let issueTypes = await getIssueTypes();
        return {
            issueTypes
        }
    } catch (e) {
        console.log(e);
        throw e;
    }
}

function* fetchIssueTypeDataSaga(action) {
    try {
        const {
            issueTypes
        } = yield call(fetchIssueTypeData);
        yield put({
            type: 'FETCH_ISSUE_TYPES_DATA_SUCCESSFUL',
            issueTypes
        })
    } catch (e) {
        yield put({ type: 'FETCH_ISSUE_TYPES_DATA_FAILED', error: e.message });
    }
}

export default fetchIssueTypeDataSaga;